/**
 * A convenience method used to simulate loading.
 * @param seconds The amount of seconds to wait.
 */
export var wait = function (seconds) {
    return new Promise(function (res) {
        setTimeout(function () { return res(); }, seconds * 1000);
    });
};
